export class RegisterAccount {
  pin: string;
  email: string;
  cardValidationId: string;
  etk: boolean;
  kvkk: boolean;
}
